export default __webpack_public_path__ + "static/tara-5ff2759f0bcd91d0c1873727a2b13e51.png";